<div class="container">
  <div class="content">
    <div class="logo-grid">
      <a href="/">
        <img
          _ngcontent-jfo-c167=""
          src="../../../assets/img/iclinic-azul-new.svg"
          alt="iClinic Pay"
          class="logo"
        />
      </a>
    </div>
    <div class="grid">
      <h3>POLÍTICA DE PRIVACIDADE DA ICLINICPAY</h3>

      <p>Bem-vindo à Política de Privacidade da IclinicPay (“Política”).</p>

      <p>
        Pedimos que você leia essa Política com atenção, ela esclarece quais
        informações pessoais podem ser acessadas e como elas serão utilizada se
        armazenadas pela Medicinae Participações Ltda. (“IclinicPay”, “nós”,
        “nos”, “nosso”). SE VOCÊ NÃO CONCORDA COM AS DISPOSIÇÕES A SEGUIR, VOCÊ
        NÃO PODERÁ SE INSCREVER NA PLATAFORMA ICLINICPAY E/OU UTILIZAR OS
        SERVIÇOS DA ICLINICPAY
      </p>

      <h4>1. INTRODUÇÃO</h4>

      <p>
        A IclinicPay busca facilitar o recebimento de créditos detidos por
        médicos, clínicas e hospitais em virtude da prestação serviços médicos a
        pacientes que são beneficiários vinculados às operadoras de planos
        privados de assistência à saúde e/ou de seguradoras que atuam no ramo da
        saúde. Para tanto, a IclinicPay presta os serviços de desconto de
        recebíveis, acompanhamento e gerenciamento do fluxo de recebíveis e
        auxílio para recuperação de glosa médica (em conjunto, os “Serviços”).
      </p>

      <p>
        A sua relação com a IclinicPay é regida pela Política e pelos Termos e
        Condições de Uso da IclinicPay (em conjunto, os “Acordos”).
      </p>

      <p>
        Você manifesta sua vontade de aderir aos Acordos ao se inscrever na
        plataforma IclinicPay e/ou utilizar de qualquer forma os Serviços. Ao se
        inscrever na plataforma IclinicPay e/ou utilizar de qualquer forma os
        Serviços, você confirma e declara que leu, compreendeu e concorda com os
        termos e condições dos Acordos. Com a adesão aos Acordos, você se
        tornará um usuário da IclinicPay (“Usuário”). Conforme afirmado acima,
        caso haja qualquer discordância e/ou ressalva com relação aos termos e
        condições dos Acordos, você não poderá utilizar os Serviços.
      </p>

      <p>
        A plataforma IclinicPay é de uso restrito para pessoas jurídicas e
        pessoas físicas maiores de 18 anos, domiciliadas no Brasil, livres,
        plenamente capazesedesimpedidas para celebrar os Acordos.
      </p>

      <p>
        A IclinicPay está empenhada em proteger a sua privacidade e a
        privacidadedos pacientes de seus Usuários.
      </p>

      <h4>2. ALTERAÇÕES DOS ACORDOS</h4>

      <p>
        Conforme os Termos e Condições de Uso da IclinicPay, nós poderemos
        alterar disposições dos Acordos a nosso critério e a qualquer tempo.
        Toda vez que alterarmos materialmente os Acordos, tais alterações serão
        válidas, eficazes e vinculantes após: (1) serem divulgadas no website da
        IclinicPay; (2) serem enviadas por e-mail ao Contratante; e/ou (3)
        comunicadas de qualquer outra forma ao Contratante. O Usuário deverá
        verificar a versão atualizada dos Acordos toda vez que visitar o website
        da IclinicPay.
      </p>

      <h4>3. INFORMAÇÕES FORNECIDAS PELO USUÁRIO</h4>

      <p>
        Em geral, você compartilha conosco 3 (três) tipos de informações: (1)
        que precisamos ter para que você utilize a plataforma IclinicPay; (2) de
        titular idade de pacientes, constantes dos documentos representativos
        dos créditos detidos pelo Usuário em virtude da prestação de serviços
        médicos a pacientes que são beneficiários vinculados às operadoras de
        planos de privados de assistência à saúde e/ou de seguradoras que atuam
        no ramo da saúde; (3) as que podemos usar para fornecer características
        adicionais e experiência aprimoradas se você decidir compartilhar tais
        informações.
      </p>

      <h4>3.1. INFORMAÇÕES FORNECIDAS PELO USUÁRIO</h4>

      <p>
        Para se cadastrar na plataforma IclinicPay e utilizar dos Serviços,
        poderemos solicitar informações como:
      </p>

      <ul>
        <li>nome completo;</li>
        <li>razão social</li>
        <li>nome de usuário</li>
        <li>n° de documento de identidade;</li>
        <li>n° do CPF ou CNPJ;</li>
        <li>estado civil;</li>
        <li>senha;</li>
        <li>endereço de e-mail;</li>
        <li>telefone;</li>
        <li>data de nascimento;</li>
        <li>sexo;</li>
        <li>endereço;</li>
        <li>código postal;</li>
        <li>país;</li>
        <li>código CNES;</li>
        <li>
          conta bancária de recebimento das operadoras de planos de privados de
          assistência à saúde e/ou de seguradoras que atuam no ramo da saúde; e
        </li>
        <li>
          contratos com as operadoras de planos de privados de assistência à
          saúde e/ou de seguradoras que atuam no ramo da saúde.
        </li>
      </ul>

      <p>
        Caso você utilize uma conta em rede social (como o Facebook) para criar
        o seu cadastro no Site, coletaremos os dados indicados no momento da
        vinculação da conta da rede social (os dados padrão de conta do Facebook
        são nome, e-mail elistade amigos, mas podemos coletar outros dados, o
        que lhe será informado no momento da coleta).
      </p>

      <p>
        Você também poderá fornecer informações adicionais voluntariamente na
        sua ficha cadastral, como os contratos com as operadoras de planos
        privados de assistência à saúde e/ou de seguradoras que atuam no ramo da
        saúde que não estejam em nossa base de cadastros no momento.
      </p>

      <p>
        Além das informações recebidas durante os processos cadastro e inscrição
        em eventos também recebemos informações suas quando você entra em
        contato conosco ou responde a uma das nossas pesquisas.
      </p>

      <p>
        A titularidade do cadastro é pessoal. Apenas o titular da conta poderá
        ter acesso aos dados relativos à mesma. Alterações em dados cadastrados
        somente poderão ser feitas pelo próprio Usuário em sua conta. A
        IclinicPay não tem prerrogativa para fazer esse tipo de alteração,
        independentemente da razão alegada ou circunstância.
      </p>

      <p>
        Você concorda que tais informações serão coletadas e mantidas e
        utilizadas pela IclinicPay para as finalidades da plataforma IclinicPay,
        emespecial paraprestar os Serviços e demais propósitos descritos nesta
        Política.
      </p>

      <P
        >Caso a IclinicPay identifique inconsistências ou eventuais riscos
        emrelação ao seu Usuário ou às suas atividades e considere necessário
        validar as informações cadastradas, você se compromete a fornecer as
        comprovações que lhe forem requisitadas.</P
      >

      <P
        >Se tivermos motivos que indiquem que dados cadastrados não são
        verdadeiros, teremos o direito de suspender ou encerrar a sua conta, bem
        como nos recusar a prover quaisquer de nossos Serviços. Qualquer erro,
        atraso, prejuízo ou dano causado devido ao cadastramento de dados
        incorretos, incompletos ou desatualizados é de total responsabilidade do
        Usuário</P
      >

      <h4>3.2. INFORMAÇÕES DE PACIENTES</h4>

      <p>
        Os documentos representativos dos créditos detidos pelo Usuário
        emvirtudeda prestação de serviços médicos a pacientes que são
        beneficiários vinculados às operadoras de planos de privados de
        assistência à saúde e/ou de seguradoras que atuam no ramo da saúde
        contém informações sigilosas sobre esses pacientes.
      </p>

      <p>
        De acordo com o artigo 73 do Código de Ética Médica, o
        médicodeveráguardar sigilo das informações que obter em virtude do
        exercício de sua profissão, salvo por motivo justo, dever legal ou
        consentimento, por escrito, do paciente.
      </p>

      <p>
        O art. 79 do Código de Ética Médica determina ainda que é vedado ao
        médico deixar de guardar o sigilo profissional na cobrança de honorários
        por meio judicial ou extrajudicial.
      </p>

      <p>
        A contratação dos Serviços não compromete o sigilo profissional, uma vez
        que as informações relativas aos pacientes dos Usuários são manuseadas
        pela Dra. Luciana Ferreira Lessa, CRM n° 780960-RJ. Portanto, as
        informações de pacientes enviadas à IclinicPay estão ainda sujeitas ao
        sigilo profissional.
      </p>

      <p>
        Destacamos ainda que uma vez processados, os dados sobre os pacientes
        são despersonalizados, umas vez que o software utilizado pela IclinicPay
        para prestação de Serviços não coleta informações pessoais, não sendo
        possível a identificação dos beneficiários do atendimento médico nem a
        identificação de seu quadro de saúde.
      </p>

      <p>
        O Usuário assegura à IclinicPay que possui todas as autorizações de
        pacientes para divulgar as informações descritas nesta seção, conforme e
        caso necessárias, bem como que indenizará e manterá a IclinicPay
        indenecontra quaisquer demandas a esse respeito.
      </p>

      <h4>3.3. INFORMAÇÕES ADICIONAIS COLETADAS</h4>

      <p>
        Quando você usar ou interagir com o Serviço, temos permissão para
        coletar informações utilizando uma série de tecnologias. Entre essas
        informações estão:
      </p>

      <ul>
        <li>
          dados técnicos, como informações de URL, dados de cookies, seu
          endereçoIP. os tipos de dispositivos que você está usando para acessar
          ou se conectaràplataforma Medicinae, o ID exclusivo do dispositivo,
          atributos do dispositivo, o tipo de conexão de rede e o desempenho do
          provedor, da redeedodispositivo, o tipo do navegador, o idioma,
          informações que permitem a gestão dos direitos autorais digitais e o
          sistema operacional;
        </li>
        <li>
          os dados sobre o faturamento, pagamento e a glosa realizada pelas
          operadoras de planos de privados de assistência à saúde e/ou de
          seguradoras que atuam no ramo da saúde.
        </li>
      </ul>

      <p>
        As informações que coletamos referentes ao endereço de IP dos Usuários
        da página e aos registros de acesso dos Usuários cadastrados são
        armazenados por pelo menos 6 (seis) meses, conforme determinado pelo
        artigo 15 da Lei nº 12.965/2014 (Marco Civil da Internet)
      </p>

      <h4>3.4. DEMAIS DADOS</h4>

      <p>
        Se você optar por pagar por boleto bancário, a Medicinae
        poderáprecisarfornecer informações como seu nome, data de nascimento e
        número de telefoneaosprocessadores de pagamentos com os quais
        trabalhamos para emitir as faturas, habilitar verificações de crédito e
        enviar suas faturas.
      </p>

      <p>
        Ao aceitar a Política, você autoriza expressamente a IclinicPay a usar e
        compartilhar com o grupo IclinicPay, assim como com determinados
        parceiros de negócios e prestadores de serviços confiáveis, que poderão
        estar localizados foradopaís de sua residência (incluindo países que não
        fornecem o mesmo nível de proteção para o processamento de dados
        pessoais que o país de sua residência), as informações fornecidas por
        você à IclinicPay.
      </p>

      <p>
        Você confirma e concorda com a importância de compartilhar tais
        informações relacionadas à prestação dos Serviços e também concorda que,
        ao aceitar essa Política, onde for aplicável e na medida permitida pela
        lei aplicável, vocêautoriza a Medicinae a compartilhar as informações de
        pagamento fornecidas por você com qualquer uma de suas controladas ou
        subsidiárias e a quaisquer parceirosde negócios e prestadores de
        serviços confiáveis, que poderão estar localizados fora do seu país de
        residência, para o fim exclusivo de viabilizar o pagamento do Serviço
        contratado por você. Esse consentimento é fornecido para todo o período
        de seu relacionamento com a IclinicPay
      </p>

      <h4>5. USO DAS INFORMAÇÕES COLETADAS</h4>

      <p>
        Nós apenas iremos coletar, armazenar, tratar, processar e/ou utilizar as
        suas informações para as finalidades descritas nesta Política.
      </p>

      <h4>
        5.1. ACESSO E UTILIZAÇÃO DA PLATAFORMA ICLINICPAY E CONTRATAÇÃO DOS
        SERVIÇOS
      </h4>

      <p>
        As informações dos Usuários da plataforma IclinicPay serão utilizadas no
        formato disposto nesta Política, incluindo, sem se limitar:
      </p>

      <ul>
        <li>
          cadastro e identificação dos Usuários junto à plataforma IclinicPay,
          inclusive mediante métodos de autenticação (por exemplo, sem se
          limitar, via mensagem de texto (SMS) ou e-mail);
        </li>
        <li>
          verificação de autenticidade das informações e documentos fornecidos,
          inclusive mediante tratamento e verificação cruzada;
        </li>
        <li>
          cobrança de prestações devidas pelos Usuários emdecorrênciadosServiços
          contratados por meio da plataforma, incluindo mediante o envio de
          mensagens de cobrança por e-mail, correio, mensagens de texto e/ou
          telefone;
        </li>
        <li>
          medidas julgadas necessárias ou recomendáveis pela IclinicPay para a
          constante melhoria das funcionalidades da plataforma IclinicPay e
          ações realizadas para a oferta dos Serviços por meio da plataforma
          IclinicPay, bem como para melhor entender as necessidades dos
          Usuários, oquepode incluir contatar os Usuários com o objetivo de
          realizar pesquisas de mercado e satisfação, a utilização das
          informações fornecidas para customização da plataforma IclinicPay de
          acordo comos interesses de cada Usuário;
        </li>
        <li>
          notificação dos Usuários a respeito de alterações na plataforma e/ou
          nos Serviços, bem como o cumprimento das obrigações advindas da lei e
          assumidas no âmbito da contratação dos Serviços e/ou do acesso e
          utilização à plataforma IclinicPay;
        </li>
        <li>
          reporte de operações, armazenamento de informações, dados,
          comunicações e outros relacionados ao acesso e utilização da
          plataforma e contratação dos Serviços, bem como o cumprimento de
          outras obrigações legais e regulatórias impostas à plataforma
          IclinicPay.
        </li>
      </ul>

      <h4>
        5.2. OFERTA E FORNECIMENTO DE INFORMAÇÕES SOBRE PRODUTOS E SERVIÇOS
      </h4>

      <p>
        A IclinicPay poderá usar as Informações dos Usuários (com exceção dos
        dados financeiros, pessoais, bancários e de patrimônio), diretamente ou
        mediante a transferência para nossos prestadores de serviço
        terceirizados, para a oferta ou o envio aos Usuários de informações
        atinentes a produtos ou serviços que possam ser de interesse dos
        Usuários, por quaisquer meios disponíveis, incluindo meios eletrônicos,
        correio ou telefone, exceto se o Usuário expressamente informar que não
        deseja ser contatado.
      </p>

      <h4>
        5.3. DECLARAÇÕES, DEPOIMENTOS OU COMENTÁRIOS SOBRE A PLATAFORMA
        ICLINICPAY E OS SERVIÇOS
      </h4>

      <p>
        Ao concordar com esta Política, o Usuário autoriza também, por meio
        desta, que a IclinicPay utilize, copie, reproduza, disponibilize,
        transmita, compartilhe, traduza para outros idiomas, insira em outros
        materiais (incluindo, sem se limitar, ao seu site, vídeos e materiais de
        publicidade) para quaisquer fins, incluindo para fins comerciais, de
        publicidade e institucionais, quaisquer declarações, depoimentos ou
        comentários, no todo ou em parte, relacionados à plataforma IclinicPay
        e/ou aos Serviços em recursos específicos disponibilizados para tais
        fins em nossa plataforma, enviados por e-mail, mensagem de texto, ou
        postados em redes sociais, tais como Facebook, Twitter, Instagram,
        Youtube e outros. Os Usuários reconhecem ainda que nós poderemos
        utilizar quaisquer referidas declarações, depoimentos ou comentários em
        associação ao seu nome completo e fotografia de perfil de redes sociais.
      </p>

      <h4>6. COMPARTILHAMENTO DOS DADOS</h4>

      <p>
        IclinicPay a concordância com os termos desta Política, o Usuário
        concorda e consente também de forma inequívoca com a concessão de acesso
        e o compartilhamento de suas informações com a IclinicPay, bem como com
        terceiros selecionados, conforme elencado abaixo, para que sejam obtidos
        os fins descritos nesta Política:
      </p>

      <ul>
        <li>
          funcionários e empresas do grupo, investidores, parceiros comerciais,
          agentes e/ou prestadores de serviços, no Brasil ou no exterior, da
          IclinicPay;
        </li>
        <li>operadores de sistemas de pagamento;</li>
        <li>
          seguradoras, corretoras de seguros, correspondentes de seguros,
          resseguradoras, e quaisquer outros fornecedores de seguros utilizados
          por nós ou quaisquer das instituições financeiras parceiras em relação
          às nossas políticas de seguro; e
        </li>
        <li>
          quaisquer outros terceiros para quem nós sejamos obrigados a
          compartilhar as informações devido a obrigações legais e regulatórias
          e/ou cuja divulgação das informações sejam necessárias ou
          recomendáveis para a devida, efetiva e eficiente operação da
          plataforma IclinicPay e suas funcionalidades, bem como para a oferta
          dos Serviços.
        </li>
      </ul>

      <h4>6. ANUNCIANTES</h4>

      <p>
        Poderemos permitir que anunciantes ou parceiros comerciais
        (“Anunciantes”) escolham os Usuários que visualizarão os seus anúncios
        e/ou ofertas promocionais de acordo com informações demográficas obtidas
        pela plataforma IclinicPay. Aoconcordar com esta Política, o Usuário
        também concorda expressamente que poderemos fornecer qualquer das suas
        informações por nós coletadas para um Anunciante, sempre de modo
        não-identificável, para que tal Anunciante possa selecionar o seu
        público apropriado para seus anúncios e/ou ofertas. Nós poderemos
        permitir que os Anunciantes exibam os seus anúncios a Usuários com
        padrões similares aos seus, tendo em vista que quaisquer informações
        divulgadas aos Anunciantes o serão de forma agregada e não
        identificável, de modo que nenhum Anunciante terá acesso a informações
        pessoais dos Usuários da plataforma IclinicPay ou poderá identificar
        qualquer Usuário da plataforma IclinicPay individualmente.
      </p>

      <h4>6.2. AGENTES</h4>

      <p>
        Nós empregamos outras companhias e pessoas (“Agentes”) para realizar
        tarefas em nosso nome, e portanto, precisamos compartilhar informações
        dos Usuários da plataforma IclinicPay com tais Agentes para que possamos
        permitir aos Usuários o acesso e utilização da plataforma IclinicPay
        e/ou a contratação dos Serviços. A menos que digamos diferentemente, os
        Agentes não têm qualquer direito de utilizar as informações que
        compartilhamos com eles além do necessário para nos auxiliar em suas
        tarefas, e/ou para a devida, efetiva e eficiente operação da plataforma
        e suas funcionalidades, bem como para a oferta dos Serviços.
      </p>

      <h4>6.3. AGÊNCIAS DE CRÉDITO, BUREAU DE CRÉDITO E OUTRAS AGÊNCIAS</h4>

      <p>
        A fim de permitir que nós possamos verificar a autenticidade das
        informações e/ou documentos fornecidos pelos Usuários para acesso e
        utilização da plataforma IclinicPay, bem como para decidir a respeito de
        pedido e/ou proposta para contratação de quaisquer Serviços, nós
        poderemos proceder e/ou requerer pesquisas, a qualquer tempo, sobre os
        registros dos Usuários em qualquer agência de notação de crédito
        relevante, agência de crédito, bureau de crédito, agência de prevenção
        de fraude (incluindo, mas sem se limitar, Boa Vista, Serasa e
        ClearSale), e/ou no Sistema de Informações de Crédito do Banco Central
        do Brasil (SCR). Tais agências podem acrescentar aos seus registros
        detalhes das nossas pesquisas, incluindo a totalidade ou parcela das
        informações, as quais poderão ser vistas por outras organizações ou
        instituições financeiras realizando pesquisas. A demais, podemos enviar
        a totalidade ou parcela das informações dos Usuários para qualquer
        agência de notação de crédito relevante, agência de crédito, bureau de
        crédito e/ou agência de prevenção de fraude (incluindo, mas sem se
        limitar, Boa Vista, Serasa e ClearSale), e/ou para o Sistema de
        Informações de Crédito do Banco Central do Brasil (SCR) (com exceção dos
        Dados Bancários obtidos através da Acesso a Conta).
      </p>

      <p>
        As informações tidas sobre os Usuários em agências de notação de
        crédito, agências de crédito, bureaus de crédito e/ou agências de
        prevenção de fraude (incluindo, mas sem se limitar, Boa Vista, Serasa e
        ClearSale), e/ou no Sistema de Informações de Crédito do Banco Central
        do Brasil (SCR) podem estar ligadas a registros relativos a um ou mais
        dos membros da família de um Usuário ou qualquer pessoa com quem o
        Usuário seja ligado financeiramente (“Associação”). Para fins de tomada
        de decisão a respeito de pedido e/ou proposta para contratação de
        Serviços por um Usuário, tal Usuário e suas respectivas Associações
        serão tratadas como financeiramente independentes e pedido e/ou proposta
        para contratação de Serviçospor um Usuário será avaliado sem qualquer
        referência aos registros das Associações. Assim, ao concordar com os
        termos desta Política, o Usuário (i) declara para todos os fins que não
        há qualquer informação relacionada a membros de sua família que possam
        afetar sua análise de crédito; e (ii) nos autoriza a checar a validade
        dessa declaração junto a agências de notação de crédito, agências de
        crédito, bureaus de crédito e/ou agências de prevenção de fraude
        (incluindo, mas semse limitar, BoaVista, Serasa e ClearSale), e/ou no
        Sistema de Informações de Crédito do Banco Central do Brasil (SCR).
      </p>

      <h4>7. SEGURANÇA</h4>

      <p>
        A sua conta na plataforma IclinicPay é protegida por uma senha pessoal e
        intrasferível, a qual existe para privacidade e segurança dos Usuários.
        Você deverá prevenir o acesso não autorizado à sua conta e às suas
        informações através da seleção e proteção adequada da sua senha, e da
        limitação do acesso ao seu computador ou dispositivo e navegador,
        cabendo a você desconectar-se da plataforma IclinicPay após terminar de
        acessar a sua conta e utilizar a plataforma IclinicPay
      </p>

      <p>
        A senha de acesso a conta de Usuário na plataforma IclinicPay é
        armazenada nos nossos bancos de dados utilizando as mais modernas formas
        de criptografia e, para garantir a sua segurança, ninguém tem acesso a
        tais bancos de dados. Isso significa que A ICLINICPAY NUNCA SOLICITARÁ
        SENHA DE ACESSO A CONTA DE USUÁRIO NA PLATAFORMA ICLINICPAY POR E-MAIL
        OU TELEFONE. Caso alguém entre em contato com você ou terceiro
        solicitando o fornecimento de sua senha de acesso a conta de Usuário na
        plataforma IclinicPay, mesmo que tal pessoa se identifique como um
        membro da equipe IclinicPay, um Agente, um Anunciante ou qualquer
        parceiro, funcionário ou prestador de serviços associado à IclinicPay,
        nós recomendamos o Usuário entre em contato com a nossa central de
        atendimento através do e-mail
        <a href="mailto:contato@medicinaesolutions.com"
          >contato@medicinaesolutions.com</a
        >.
      </p>

      <p>
        Se você tiver qualquer motivo para acreditar ou suspeitar que qualquer
        terceiro teve acesso à sua senha de acesso à conta de Usuário, pedimos
        que, por favor, entre em contato com nossa central de atendimento. A
        IclinicPay estará pronta para atender sua solicitação e iniciar as
        medidas de segurança e verificação necessárias para bloqueio da senha
        existente e emissão de uma nova senha.
      </p>

      <p>
        Nós nos esforçaremos para proteger a privacidade da conta de nossos
        Usuários e outras informações que guardarmos em nossos registros,
        contudo, nós não podemos garantir a mais completa segurança de nossos
        Usuários. O acesso ou uso não autorizado, a falha do hardware ou
        software e outros fatores podem comprometer a segurança das informações
        do Usuário a qualquer tempo.
      </p>

      <p>
        NESTE SENTIDO, A TRANSMISSÃO DE INFORMAÇÕES PELA INTERNET NÃO
        ÉCOMPLETAMENTE SEGURA POR DIVERSOS FATORES, INCLUINDO FATORES DE REDE E
        DE OPERAÇÃO, E A ICLINICPAY NÃO TEM COMO GARANTIR A COMPLETA SEGURANÇA
        DOS DADOS TRANSMITIDOS PELOS USUÁRIOS À PLATAFORMA ICLINICPAY. APESAR DE
        FAZERMOS O NOSSO MELHOR PARA PROTEGER AS INFORMAÇÕES PESSOAIS DOS
        USUÁRIOS, NÓS NÃO PODEMOS GARANTIR A SEGURANÇA DOS DADOS TRANSMITIDOS À
        NOSSA PLATAFORMA. QUALQUER TRANSMISSÃO É DE EXCLUSIVA RESPONSABILIDADE
        DOS USUÁRIOS, OS QUAIS, AO CONCORDAR COM A PRESENTE RECONHECEM E ASSUMEM
        EXPRESSAMENTE TAL RESPONSABILIDADE.
      </p>

      <P
        >Uma vez recebidas informações dos Usuários pela plataforma IclinicPay,
        nós nos comprometemos a assegurar que tais estarão seguras no ambiente
        da plataforma IclinicPay. Para prevenir o acesso ou divulgação não
        autorizada das informações de Usuários, nós implementamos procedimentos
        físicos, eletrônicos e administrativos adequados para assegurar e
        proteger as informações que coletamos.</P
      >

      <h4>8. DISPOSIÇÕES GERAIS</h4>

      <h4>8.1. PROTEÇÃO DA ICLINICPAY</h4>

      <p>
        Nós nos reservamos no direito de acessar, ler, preservar e divulgar
        qualquerinformação que acreditemos ser necessária para cumprir ou
        aplicar comalei ou ordem judicial na medida requerida pela legislação e
        regulamentação aplicáveis e os Acordos, bem como proteger os direitos,
        propriedade ou segurança da IclinicPay, daplataforma IclinicPay e seus
        respectivos funcionários, prestadores deserviço, Usuários, clientes e
        outros.
      </p>

      <h4>8.2. COOKIES</h4>

      <p>
        Cookie é um pequeno arquivo adicionado ao dispositivo ou computador do
        Usuário para fornecer uma experiência personalizada de acesso à
        plataforma IclinicPay. Os cookies ajudam a analisar o tráfico de
        internet ou nos permite saber quando o Usuário visitou um site
        específico. Um cookie não dá acesso a um computador ou revela
        informações além dos dados que o Usuário escolhe compartilhar conosco.
      </p>

      <p>
        <strong
          >Sempre que o Usuário interagir com a plataforma IclinicPay e/ou com
          os Serviços, nós automaticamente recebemos e armazenamos informações
          do navegador ou dispositivo do Usuário em nossos registros de servidor
          (“Dados de Registro”), o que inclui: endereço de IP , identificação de
          dispositivo, página ou recurso visitado, tempo gasto em cada uma
          dessas páginas, horários edatasdeacesso, tipo de navegador e
          dispositivo utilizado, a página ou recursoqueutilizado para localizar
          a plataforma IclinicPay e informação pesquisadaparatanto.</strong
        >
      </p>

      <p>
        Os Anunciantes e parceiros da plataforma IclinicPay, conforme o caso não
        transmitem cookies para o navegador ou dispositivo dos Usuários quando a
        plataforma IclinicPay é utilizada. Contudo, quando o Usuário clica em
        anúncios ou links que levam a um site ou serviço de terceiro, este
        terceiro poderá transmitir cookies a tal Usuário. Lembramos que essa
        Política não abrange o uso de cookies por quaisquer terceiros, e não nos
        responsabilizamos pelas práticas e políticas de privacidade dos mesmos.
      </p>

      <p>
        O seu navegador pode oferecer a opção de desabilitar cookies. Caso um
        você opte por desabilitar cookies quando da tentativa de acesso e/ou
        utilização da plataforma IclinicPay, o Usuário não conseguirá acessar
        e/ou utilizar a Plataforma IclinicPay e, portanto, contratar os Serviços
        ofertados pela Plataforma IclinicPay.
      </p>

      <h4>8.3. CONTROLANDO AS SUAS INFORMAÇÕES PESSOAIS</h4>

      <p>
        Você poderá requisitar detalhes das informações pessoais guardadas por
        nós. Sevocê quiser uma cópia das informações que temos a seu respeito,
        por favor envie um e-mail para
        <a href="mailto:contato@medicinaesolutions.com"
          >contato@medicinaesolutions.com</a
        >
      </p>

      <h4>9. CONTATO DA ICLINICPAY</h4>

      <p>
        Se você tiver dúvidas relacionadas aos Serviços ou aos Acordos, entre em
        contato com o atendimento ao cliente da IclinicPay através da seção
        “Fale Conosco”do nosso site.
      </p>

      <h4>10. EXCLUSÕES</h4>

      <p>
        Essa Política aplica-se somente à plataforma IclinicPay e à utilização
        dos Serviços. Podemos incluir no links para páginas ou serviços de
        terceiros, e você está ciente de que tais sites de terceiros não estão
        sujeitos a esta Política de Privacidade
      </p>

      <p>
        Nós agradecemos a preferência e a leitura dos Termos. Esperamos que
        aproveite nossos Serviços.
      </p>

      <p>Entidade contratante:</p>

      <p>
        <strong>Medicinae Participações S.A.</strong> <br />
        Av. João Cabral de Mello Neto, 850, Bloco 2, Sala 215 – CEO West<br />
        Barra da Tijuca, CEP 22775-057<br />
        Rio de Janeiro – RJ<br />
        Brasil<br />
        CNPJ n° 26.753.786/0001-01
      </p>
    </div>
  </div>
</div>
